import { store } from '@/store/store'

export const requestBody = {

  getRequestBody ({ methodName, methodParameters }) {
    methodParameters = JSON.parse(JSON.stringify(methodParameters))
    if (this[methodName + 'RequestBody']) {
      return this[methodName + 'RequestBody']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  initRequestBody ({ methodParameters }) {
    let merchantName = store.getters.dpaId.displayDpaName
    let { srciTransactionId, dpaTransactionOptions, sdkSpecificParameters } = methodParameters
    let specificParameters = sdkSpecificParameters.visa
    let sdkSpecificDpaTransactionOptions = specificParameters.dpaTransactionOptions
    dpaTransactionOptions = this.getDpaTransactionOptions({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions })
    if ((dpaTransactionOptions.transactionAmount || {}).transactionAmount) {
      dpaTransactionOptions.transactionAmount.transactionAmount =
        dpaTransactionOptions.transactionAmount.transactionAmount.toString()
    }
    return {
      srciTransactionId,
      srcInitiatorId: specificParameters.srcInitiatorId,
      srciDpaId: specificParameters.srcDpaId,
      dpaData: { dpaPresentationName: merchantName },
      dpaTransactionOptions
    }
  },

  isRecognizedRequestBody ({ methodParameters }) {
    let recognitionToken = store.getters.recognitionToken
    let environment = store.getters.environment
    if (recognitionToken[environment]) {
      methodParameters['recognitionTokens'] = [recognitionToken[environment]]
    }
    return methodParameters
  },

  identityLookupRequestBody ({ methodParameters }) {
    let consumerIdentity = { ...methodParameters.consumerIdentity }
    let _identityType = consumerIdentity.identityType
    delete consumerIdentity.identityType
    consumerIdentity.type = _identityType === 'EMAIL_ADDRESS' ? 'EMAIL' : 'MOBILE_NUMBER'
    if (consumerIdentity.type === 'MOBILE_NUMBER') {
      let { mobileNumber } = consumerIdentity.identityValue
      consumerIdentity.identityValue = mobileNumber.countryCode + '' + mobileNumber.phoneNumber
    } else {
      consumerIdentity.identityValue = consumerIdentity.identityValue.email
    }
    return consumerIdentity
  },

  completeIdentityValidationRequestBody ({ methodParameters }) {
    let complianceSettings
    let appInstance
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
      appInstance = {
        userAgent: window.navigator.userAgent
      }
      return { ...methodParameters, complianceSettings, appInstance }
    }
    return { ...methodParameters }
  },

  checkoutRequestBody ({ methodParameters }) {
    let { dpaTransactionOptions, sdkSpecificDpaTransactionOptions } = methodParameters
    let complianceSettings
    dpaTransactionOptions = this.getDpaTransactionOptions({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions })
    if ((dpaTransactionOptions.transactionAmount || {}).transactionAmount) {
      dpaTransactionOptions.transactionAmount.transactionAmount =
        dpaTransactionOptions.transactionAmount.transactionAmount.toString()
    }
    delete methodParameters.network
    delete methodParameters.dpaTransactionOptions
    delete methodParameters.sdkSpecificDpaTransactionOptions
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
    } else {
      complianceSettings = store.getters.complianceSettingsObj
    }

    return { ...methodParameters, dpaTransactionOptions, complianceSettings }
  },

  unbindAppInstanceRequestBody ({ methodParameters }) {
    let recognitionToken = store.getters.recognitionToken
    let environment = store.getters.environment
    if (recognitionToken[environment]) {
      methodParameters['recognitionTokens'] = recognitionToken[environment]
    }
    return methodParameters
  },

  getDpaTransactionOptions ({ dpaTransactionOptions, sdkSpecificDpaTransactionOptions }) {
    dpaTransactionOptions = {
      ...dpaTransactionOptions,
      ...sdkSpecificDpaTransactionOptions
    }
    dpaTransactionOptions.customInputData = { 'customFlowType': store.getters.visaDcfPreference }
    delete dpaTransactionOptions.payloadTypeIndicatorCheckout
    delete dpaTransactionOptions.payloadTypeIndicatorPayload
    delete dpaTransactionOptions.isGuestCheckout
    delete dpaTransactionOptions.threeDsPreference
    delete dpaTransactionOptions.confirmPayment
    return dpaTransactionOptions
  }
}
